export const FETCH_MEDICAL_SUPLIES_REQUEST = "FETCH_MEDICAL_SUPLIES_REQUEST";
export const FETCH_MEDICAL_SUPLIES_SUCCESS = "FETCH_MEDICAL_SUPLIES_SUCCESS";
export const FETCH_MEDICAL_SUPLIES_FAIL = "FETCH_MEDICAL_SUPLIES_FAIL";

export const CREATE_MEDICAL_SUPLIES_REQUEST = "CREATE_MEDICAL_SUPLIES_REQUEST";
export const CREATE_MEDICAL_SUPLIES_SUCCESS = "CREATE_MEDICAL_SUPLIES_SUCCESS";
export const CREATE_MEDICAL_SUPLIES_FAIL = "CREATE_MEDICAL_SUPLIES_FAIL";

export const SHOW_MEDICAL_SUPLIES_REQUEST = "SHOW_MEDICAL_SUPLIES_REQUEST";
export const SHOW_MEDICAL_SUPLIES_SUCCESS = "SHOW_MEDICAL_SUPLIES_SUCCESS";
export const SHOW_MEDICAL_SUPLIES_FAIL = "SHOW_MEDICAL_SUPLIES_FAIL";

export const UPDATE_MEDICAL_SUPLIES_REQUEST = "UPDATE_MEDICAL_SUPLIES_REQUEST";
export const UPDATE_MEDICAL_SUPLIES_SUCCESS = "UPDATE_MEDICAL_SUPLIES_SUCCESS";
export const UPDATE_MEDICAL_SUPLIES_FAIL = "UPDATE_MEDICAL_SUPLIES_FAIL";
